'use strict';
const angular = require('angular');
// var baseUrl = 'https://jsapi.mtcanalytics.org/toc'; //Local
// var baseUrl = 'https://jsapi.mtcanalytics.org/tocdev' //Dev
var baseUrl = 'https://jsapi.mtcanalytics.org/tocstaging' //Staging
// var baseUrl = 'https://jsapi.mtcanalytics.org/toc' //Production

// var adminBaseURL = 'https://jsapi.mtcanalytics.org/auth'; //Local API
var adminBaseURL = 'https://jsapi.mtcanalytics.org/authstaging' //Staging
// var adminBaseURL = 'https://jsapi.mtcanalytics.org/auth' // Production

/*@ngInject*/
export function baseConfigService() {
	  //Base URL
    this.getBaseURL = function () {
      return baseUrl;
    };

     //Auth Base URL
     this.getAdminBaseURL = function () {
      return adminBaseURL;
    };
}

export default angular.module('appApp.baseConfig', [])
  .service('baseConfigService', baseConfigService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/baseConfig/baseConfig.service.js